import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled, { keyframes, css } from 'styled-components'
import { hideToast } from '../../store/toastSlice'

const Toast = () => {
	const dispatch = useDispatch()
	const { value: show, msg, type } = useSelector(state => state.toast)

	useEffect(() => {
		if (show) {
			// 1.0s 후 FadeOut + 애니메이션 0.7s 총 1.2s초 뒤에 숨기기
			const timer = setTimeout(() => {
				dispatch(hideToast())
			}, 1200)
			return () => clearTimeout(timer)
		}
	}, [show, dispatch])

	if (!show) return null

	return <ToastWrapper type={type}>{msg}</ToastWrapper>
}

const typeRgb = {
	main: "112,188,232",
	deep: "63,119,175",
	highlight: "255,207,104",
	sub: "219,226,239",
	default: "119,119,119",
}

const fadeIn = keyframes`
	from { opacity: 0 }
	to { opacity: 1 }
`

const fadeOut = keyframes`
	from { opacity: 1 }
	to { opacity: 0 }
`

const ToastWrapper = styled.div`
	font-weight: 300;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	justify-content: center;
	align-items: center;
	&& { padding: 2rem 4rem; }
	color: #fff;
	padding: 1rem 2rem;
	border-radius: 8px;
	font-size: 1.6rem;
	z-index: 9999;
	white-space: pre-wrap;
	background-color: ${({ type }) => `rgba(${typeRgb[type] || typeRgb.default}, 0.75)`};
	animation:
		${fadeIn} 0.2s ease-out forwards,
		${fadeOut} 0.5s ease-in 0.7s forwards;
`

export default Toast